// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CloseSmallIconSignature {
  Element: SVGSVGElement;
}

export const CloseSmallIcon: TOC<CloseSmallIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.4446 6L12 10.4446L7.5554 6L6 7.5554L10.4446 12L6 16.4446L7.5554 18L12 13.5554L16.4446 18L18 16.4446L13.5554 12L18 7.5554L16.4446 6Z"/>
</svg>
</template>;